<script>
import { GuardianshipService } from '../../services/GuardianshipService';

export default {
  name: 'ExistingGuardians',
  props: {
    wards: {
      type: Array,
      required: true,
    },
  },

  computed: {
    existingGuardians() {
      const guardians = [];

      this.wards.forEach((ward) => {
        ward.guardians.forEach((guardian) => {
          if (!guardians.find((g) => g.key === guardian.key)) {
            guardian.wards = [ward.name];
            guardians.push(guardian);
          } else {
            guardians.find((g) => g.key === guardian.key).wards.push(ward.name);
          }
        });
      });
      return guardians;
    },
  },

  methods: {
    async reSendCode(guardian) {
      const wardsMagicCodes = this.wards.reduce((acc, ward) => {
        if (ward.guardians.map((obj) => obj.key).includes(guardian.key))
          acc.push(ward.magic_code);
        return acc;
      }, []);
      await GuardianshipService.reSendCode(guardian.key, wardsMagicCodes);
    },
    contactLabel(contact) {
      return contact.includes('@') ? this.$t('signUp.email') : this.$t('signUp.phone');
    },
  },
};
</script>

<template>
  <div class="existing-guardians">
    <a-text class="text-grey-50 existing-guardians-subtitle">
      {{ $t('signUp.existingGuardiansDesc') }}
    </a-text>
    <div class="guardian-list">
      <a-card
        v-for="(guardian, index) in existingGuardians"
        :key="index"
        class="my-1 bottomless-cards guardian-card"
      >
        <div class="guardian-container">
          <div class="guardian-name">
            <a-text class="text-grey-50" variant="regular-xs">
              {{ $t('signUp.name') }}
            </a-text>
            <a-text class="text-wrap-nowrap" variant="regular-s">
              {{ guardian.name }}
            </a-text>
          </div>
          <div class="guardian-contact-container">
            <div class="guardian-contact">
              <a-text class="text-grey-50" variant="regular-xs">
                {{ contactLabel(guardian.contact) }}
              </a-text>
              <a-text class="text-wrap-nowrap" variant="regular-s">
                {{ guardian.contact }}
              </a-text>
            </div>
            <a-button
              class="resend-code"
              v-if="guardian.resend_code == true"
              variant="tertiary"
              @click="reSendCode(guardian)"
            >
              <a-text class="text-wrap-nowrap" variant="regular-s">
                {{ $t('signUp.resendCode') }}
              </a-text>
            </a-button>
          </div>
        </div>
      </a-card>
    </div>
  </div>
</template>

<style scoped lang="scss">
.existing-guardians {
  .guardian-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .guardian-card {
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #d3d3d3;
    margin: 0;
  }
  .guardian-card:last-child {
    margin-bottom: 16px;
  }
  .guardian-container {
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 16px;
    .resend-code {
      .a-button-container {
        justify-content: center;
      }
    }
  }
  .guardian-contact-container {
    display: flex;
  }
  @media (min-width: 480px) {
    .guardian-container {
      gap: 16px;
      .resend-code {
        margin-left: auto;
      }
    }
  }
  .existing-guardians-subtitle {
    margin-bottom: 16px;
  }
}
</style>
